import { all } from 'redux-saga/effects'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { watchFetchTodos } from './fetachTodoSaga'
import { watchFetchListGame } from './fetchGameListSaga'
import { watchUser } from './fetchUserSage'
import { initialize } from './initializeSaga'
import { routerHandlerSaga } from './routerHandlerSaga'
import { FixTypeLater } from 'react-redux'
import { watchYeekeeGame } from './yeekeeSaga'
import { watchGlobalError } from './errorHandlerSaga'
import { watchFetchLimit } from './limitHandlerSaga'
import { watchViewTicket } from './viewTicketSaga'
import {
  ACCESS_TOKEN_STORAGE_KEY,
  TOKEN_STORAGE_KEY,
} from '@/constants/storage'

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
}

export const callAPI = async ({
  url,
  method,
  data,
  headers = {},
}: AxiosRequestConfig & { method?: HttpMethod }): Promise<AxiosResponse> => {
  const maxRetries = method === HttpMethod.POST ? 0 : 3
  let attempt = 0

  // Set default headers including tokens
  headers = {
    ...headers,
    Authorization: `Bearer ${localStorage.getItem(TOKEN_STORAGE_KEY)}`,
    AccessToken: localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY),
  }

  while (attempt <= maxRetries) {
    try {
      const response = await axios({
        url,
        method,
        data,
        headers,
        timeout: 5000, // Set timeout in ms (adjust as needed)
      })
      return response // Return response if successful
    } catch (error: unknown) {
      if (axios.isAxiosError(error) && error.code === 'ECONNABORTED') {
        if (method === HttpMethod.POST) {
          // POST (e.g. bet): reject with stable code for frontend to show friendly message
          return Promise.reject(
            Object.assign(new Error('ERROR_REQUEST_TIMEOUT'), {
              code: 'ECONNABORTED',
              isTimeout: true,
            }),
          )
        }
        attempt++
        console.warn(`Request timeout. Retry attempt ${attempt}/${maxRetries}`)

        if (attempt >= maxRetries) {
          window.location.href = '/session_error'
          throw new Error('Redirecting to session error due to timeout.')
        }
      } else {
        console.error('API call failed with error:', error)
        return Promise.reject(error)
      }
    }
  }

  throw new Error('Unexpected error in API call.')
}

export const callPublicAPI = async ({
  url,
  method,
  data, // headers
}: AxiosRequestConfig): Promise<FixTypeLater> => {
  return await axios({
    url,
    method,
    data,
    // headers
  })
}

export interface ResponseStructure {
  status: string
  message: string
}

export interface ResponsePaginationStructure {
  limit: number
  page: number
  count: number
}

export interface PaginationPayloadPaginationStructure {
  page: number
  pageSize: number
}
function* rootSaga() {
  yield all([
    watchGlobalError(),
    watchFetchTodos(),
    watchFetchListGame(),
    watchYeekeeGame(),
    watchFetchLimit(),
    watchUser(),
    initialize(),
    routerHandlerSaga(),
    watchViewTicket(),
  ])
}
export default rootSaga
